module.exports = __webpack_public_path__ + "7b54f2e18e7c8fe1c97e354b67e3eff7.pdf";